<script>
import Vue from "vue";

export default {
  props: ["template", "placeholder"],
  data() {
    return {
      templateRender: null
    };
  },
  render(h) {
    if (!this.templateRender) {
      return h("div", this.placeholder || "loading...");
    } else {
      // If there is a template, I'll show it
      return this.templateRender();
    }
  },
  methods: {
    toggleGlossary(id) {
      this.$emit("toggleGlossary", id);
    }
  },
  watch: {
    // Every time the template prop changes, I recompile it to update the DOM
    template: {
      immediate: true, // makes the watcher fire on first render, too.
      handler() {
        var res = Vue.compile(this.template);

        this.templateRender = res.render;

        // staticRenderFns belong into $options,
        // appearantly
        this.$options.staticRenderFns = [];

        // clean the cache of static elements
        // this is a cache with the results from the staticRenderFns
        this._staticTrees = [];

        // Fill it with the new staticRenderFns
        for (var i in res.staticRenderFns) {
          //staticRenderFns.push(res.staticRenderFns[i]);
          this.$options.staticRenderFns.push(res.staticRenderFns[i]);
        }
      }
    }
  }
};
</script>
